/**
 * Created by alvinoktavianus on 6/22/17.
 */

import { put, takeLatest } from 'redux-saga/effects';

import * as actNotif from '../../actions/notifications';
import { BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION } from '../../actions/billingNotification/constant';

export function* showBillingNotificationFlow(request) {
  const { notificationMessage, notificationType } =
    request.payload.billingNotification;
  // eslint-disable-next-line default-case
  switch (notificationType) {
    case 'success':
      yield put(actNotif.success(notificationMessage));
      break;
    case 'pending':
      yield put(actNotif.warning(notificationMessage));
      break;
    case 'failed':
      yield put(actNotif.error(notificationMessage));
      break;
  }
}

export default function* billingNotificationSaga() {
  yield takeLatest(
    BILLING_NOTIFICATION_SHOW_BILLING_NOTIFICATION,
    showBillingNotificationFlow
  );
}
